export default {
  sorry: 'Lo sentimos',
  sorryClass: 'Lo sentimos, no hemos encontrado tarifas ',
  weFound: 'no hemos encontrado ',
  noResults: 'resultados',
  fares: '',
  theseDates: ' en esa fecha.',
  matchingSearch: 'que coincidieran con tu búsqueda.',
}
